import { Signal } from '@angular/core';
import { FrontendThemeItem } from '@tourfold/libraries/tf-api-client-frontend-v2';
import { providePageContext } from '@tourfold/shared-kernels/page-context';

const MAX_VISIBLE_THEMES = 25;

export interface ThemeSettingsAiPageContextSignals {
  readonly themes: Signal<readonly FrontendThemeItem[]>;
  readonly editingTheme: Signal<FrontendThemeItem | null>;
  readonly editorName: Signal<string>;
}

/**
 * Registers AI assistant page context for the Themes settings page.
 *
 * Visible rows carry the first 25 theme cards so Ask Rob and MCP callers can resolve a
 * theme name to its id. When the editor is open, `entity` points at that specific theme;
 * the live editor name is used so newly created or renamed themes stay identifiable.
 */
export function provideThemeSettingsAiPageContext(state: ThemeSettingsAiPageContextSignals): void {
  providePageContext(() => {
    const editing = state.editingTheme();
    const editorName = state.editorName().trim();

    return {
      entity: editing
        ? {
            type: 'frontend_theme',
            id: themeContextId(editing),
            label: editorName || editing.name,
          }
        : undefined,
      visible_rows: state
        .themes()
        .slice(0, MAX_VISIBLE_THEMES)
        .map((theme) => ({
          type: 'frontend_theme',
          id: themeContextId(theme),
          label: theme.name,
        })),
    };
  });
}

function themeContextId(theme: FrontendThemeItem): string {
  return theme.id ?? 'default';
}
